function openCustomCart() {

    const cartDrawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer');

    if (cartDrawer) {

        if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
            return;
        }

        const dialog = cartDrawer.querySelector('dialog');

        if (dialog) {
            dialog.showModal();
            return;
        }
    }

    window.location.href = window.Shopify.routes.root + 'cart';
}